<div
  [ngbTooltip]="minDisabledTooltipText"
  [disableTooltip]="!minimumOrderIndication || canDecrement"
  [container]="tooltipContainer"
>
  <button
    class="modifier subtract h-100"
    type="button"
    (click)="onDecrement()"
    [disabled]="disabled || readOnly || !canDecrement"
    tabindex="-1"
    [attr.aria-label]="'common.decreaseQuantity_action' | cxTranslate"
  >
    <i nz-icon nzType="minus"></i>
  </button>
</div>

<input
  #inputRef
  type="number"
  inputmode="numeric"
  [id]="'' | randomId"
  pattern="[0-9]*"
  [min]="min"
  [max]="max"
  [ngModel]="value"
  (ngModelChange)="onInputChange($event)"
  (focus)="onInputFocus()"
  (blur)="onInputBlur()"
  [readOnly]="readOnly"
  [disabled]="disabled"
  [attr.aria-label]="'common.quantity_heading' | cxTranslate"
/>
<button
  class="modifier add"
  type="button"
  (click)="onIncrement()"
  [disabled]="disabled || readOnly || !canIncrement"
  tabindex="-1"
  [attr.aria-label]="'common.increaseQuantity_action' | cxTranslate"
>
  <i nz-icon nzType="plus"></i>
</button>
